import { Navigate } from 'react-router-dom';
import { routeUrls as routeUrl } from '../RouteUrls';
import { EcosystemViewport } from '../Viewport';
import { EcosystemRootIndexPath } from '../Components';
import { OnboardingPage } from '../../../pages/OnboardingPage';
import { SelectEcosystemPage } from '../../../pages/SelectEcosystemPage';
import { WorkflowsPage } from '../../../pages/WorkflowsPage';
import { HomePage } from '../../../pages/HomePage';
import { ThingsGroupsPage } from '../../../pages/ThingsGroupsPage';
import { ThingsPage } from '../../../pages/ThingsPage';
import { FlowBuilder2Page } from '../../../pages/FlowBuilder2Page';
import { ThingPage } from '../../../pages/ThingPage';
import { WorkboardPage } from '../../../pages/WorkboardPage';
import { WorkPage } from '../../../pages/WorkPage';
import { PerformancePage, PerformanceReportRedirector } from '../../../pages/PerformancePage';
import { PerformanceReportBuilderPage } from '../../../pages/PerformanceReportBuilderPage/PerformanceReportBuilderPage';
import { lazy } from 'react';
import { Checkout } from '../../../pages/Checkout/Checkout';
import { CheckoutReturn } from '../../../pages/Checkout/CheckoutReturn';
import { SchemaExplorerPage } from '../../../pages/SchemaExplorerPage/SchemaExplorerPage';

const WorkPrintPage = lazy(() => import('../../../pages/WorkPrintPage'));
const VideoChatPage = lazy(() => import('../../../pages/VideoChatPage'));

export function EcosystemRoutes() {
  return [
    {
      path: routeUrl.environment.path,
      element: <Navigate to={routeUrl.selectEcosystem.url(null, null)} replace />,
    },
    {
      path: routeUrl.ecosystem.path,
      element: <Navigate to={routeUrl.selectEcosystem.url(null, null)} replace />,
    },
    {
      path: routeUrl.createEnvironment.path,
      element: <Navigate to={routeUrl.createEcosystem.url(null, null)} replace />,
    },
    {
      Component: EcosystemViewport,
      children: [
        { path: routeUrl.createEcosystem.path, Component: OnboardingPage },
        { path: routeUrl.selectEcosystem.path, Component: SelectEcosystemPage },
        { path: routeUrl.checkout.path, Component: Checkout },
        { path: routeUrl.checkoutReturn.path, Component: CheckoutReturn },
      ],
    },
    {
      path: routeUrl.root.path,
      Component: EcosystemViewport,
      children: [
        { index: true, Component: EcosystemRootIndexPath },
        { path: routeUrl.workflows.path, Component: WorkflowsPage },
        { path: routeUrl.home.path, Component: HomePage },
        { path: routeUrl.flowBuilder.path, Component: FlowBuilder2Page },
        { path: routeUrl.workboard.path, Component: WorkboardPage },
        { path: routeUrl.work.path, Component: WorkPage },
        { path: routeUrl.workVideoChat.path, Component: VideoChatPage },
        { path: routeUrl.workPrint.path, Component: WorkPrintPage },
        { path: routeUrl.performance.path, Component: PerformancePage },
        { path: routeUrl.performanceReport.path, Component: PerformanceReportRedirector },
        { path: routeUrl.performanceReportBuilder.path, Component: PerformanceReportBuilderPage },
        { path: routeUrl.people.path, element: <ThingsPage peoplePage /> },
        { path: routeUrl.user.path, element: <ThingPage peoplePage /> },
        { path: routeUrl.thingsGroups.path, Component: ThingsGroupsPage },
        { path: routeUrl.things.path, Component: ThingsPage },
        { path: routeUrl.thing.path, Component: ThingPage },
        { path: routeUrl.baseWorkboard.path, Component: EcosystemRootIndexPath },
        { path: routeUrl.baseWork.path, Component: EcosystemRootIndexPath },
        { path: routeUrl.schemaExplorer.path, Component: SchemaExplorerPage },
      ],
    },
  ];
}
